// extracted by mini-css-extract-plugin
export default {"component":"HomeLayout_component__Ph0l+","centerItems":"HomeLayout_centerItems__ImjHL","contentDiv":"HomeLayout_contentDiv__H49lx"};